import component from './AppsumoSettings.vue'
export default component
